import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "./ui/accordion";

export const FAQ = ({ items }) => (
  <Accordion type="single" collapsible className="w-full">
    {items.map((f, i) => (
      <AccordionItem
        key={i}
        value={`faq-${i}`}
        className="border-b border-[#07130C]/10"
      >
        <AccordionTrigger
          data-testid={`faq-trigger-${i}`}
          className="py-6 text-left font-display text-base font-semibold text-[#07130C] hover:no-underline md:text-lg"
        >
          {f.q}
        </AccordionTrigger>
        <AccordionContent
          data-testid={`faq-content-${i}`}
          className="pb-6 text-base leading-relaxed text-[#07130C]/60"
        >
          {f.a}
        </AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);
